import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Login from "./pages/Login";
import ClientDashboard from "./pages/ClientDashboard.jsx";
import Withdraw from "./pages/Withdraw.jsx";
import History from "./pages/History.jsx"; // ← History page
import MyCard from "./pages/MyCard.jsx"; // ← Add MyCard import

import AgentDashboard from "./pages/AgentDashboard.jsx";
import AddClient from "./pages/AddClient.jsx";
import ManageClients from "./pages/ManageClients.jsx";
import EditTransactions from "./pages/EditTransactions.jsx";

import AddAgent from "./pages/AddAgent.jsx";
import ManageAgents from "./pages/ManageAgents.jsx";   // ← NEW

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  const currentUser = localStorage.getItem("currentUser");
  const userRole = localStorage.getItem("userRole");

  const isClient = currentUser && userRole === "client";
  const isAgent = currentUser && userRole === "agent";

  return (
    <BrowserRouter>
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
      <Routes>
        {/* Public Route */}
        <Route
          path="/"
          element={currentUser ? <Navigate to="/dashboard" /> : <Login />}
        />

        {/* Shared Dashboard Entry Point */}
        <Route
          path="/dashboard"
          element={
            currentUser ? (
              isClient ? <ClientDashboard /> : isAgent ? <AgentDashboard /> : <Navigate to="/" />
            ) : (
              <Navigate to="/" />
            )
          }
        />

        {/* Client Routes */}
        <Route
          path="/withdraw"
          element={isClient ? <Withdraw /> : <Navigate to="/" />}
        />
        <Route
          path="/history"
          element={isClient ? <History /> : <Navigate to="/" />}
        />
        <Route
          path="/my-card"
          element={isClient ? <MyCard /> : <Navigate to="/" />}
        />

        {/* Agent-Only Routes */}
        <Route
          path="/add-client"
          element={isAgent ? <AddClient /> : <Navigate to="/" />}
        />
        <Route
          path="/manage-clients"
          element={isAgent ? <ManageClients /> : <Navigate to="/" />}
        />
        <Route
          path="/edit-transactions"
          element={isAgent ? <EditTransactions /> : <Navigate to="/" />}
        />

        {/* buksna-Only Routes */}
        <Route
          path="/add-agent"
          element={isAgent ? <AddAgent /> : <Navigate to="/" />}
        />
        <Route
          path="/manage-agents"
          element={isAgent ? <ManageAgents /> : <Navigate to="/" />}
        />

        {/* Catch-all */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
